import { EMPTY_LIST } from '../../../../../../constants/common'
import {
  getPhotoDisplayName,
  getPhotoImageSrc,
  toPhotoFormValues,
} from '../../../../RentalPortalPhotoGallery'

import {
  LISTING_PHOTO_MOSAIC_ADD_CELL_ID,
  LISTING_PHOTO_MOSAIC_CELL_TYPE,
  LISTING_PHOTO_MOSAIC_EMPTY_CELL_ID,
  LISTING_PHOTO_MOSAIC_GRID_SIZE,
} from './RentalPortalListingPhotoMosaic.constants'

export function toListingMosaicPhotos(photos) {
  return toPhotoFormValues(photos ?? EMPTY_LIST)
}

export function getListingMosaicLeadIndex({ coverIndex, leadPhotoId, photos }) {
  const leadPhoto = photos.find(photo => photo.id === leadPhotoId)

  return leadPhoto ? photos.indexOf(leadPhoto) : coverIndex
}

export function getListingMosaicCells({ hasAddTile, leadIndex, photos }) {
  const gridPhotos = photos.filter((photo, index) => index !== leadIndex)

  const photoCapacity = LISTING_PHOTO_MOSAIC_GRID_SIZE - (hasAddTile ? 1 : 0)

  const visiblePhotos = gridPhotos.slice(0, photoCapacity)

  const hiddenCount = gridPhotos.length - visiblePhotos.length

  const photoCells = visiblePhotos.map((photo, index) => ({
    id: photo.id,
    moreCount: index === visiblePhotos.length - 1 ? hiddenCount : 0,
    photo,
    type: LISTING_PHOTO_MOSAIC_CELL_TYPE.photo,
  }))

  const isAddTileWide =
    hasAddTile &&
    photoCells.length % 2 === 0 &&
    photoCells.length + 1 < LISTING_PHOTO_MOSAIC_GRID_SIZE

  const addCells = hasAddTile
    ? [
        {
          id: LISTING_PHOTO_MOSAIC_ADD_CELL_ID,
          isWide: isAddTileWide,
          type: LISTING_PHOTO_MOSAIC_CELL_TYPE.add,
        },
      ]
    : EMPTY_LIST

  const emptyCells = Array.from(
    {
      length:
        LISTING_PHOTO_MOSAIC_GRID_SIZE -
        photoCells.length -
        addCells.length -
        (isAddTileWide ? 1 : 0),
    },
    (item, index) => ({
      id: `${LISTING_PHOTO_MOSAIC_EMPTY_CELL_ID}-${index}`,
      type: LISTING_PHOTO_MOSAIC_CELL_TYPE.empty,
    })
  )

  return [...photoCells, ...addCells, ...emptyCells]
}

export function getListingMosaicPhotoAlt(photo, t) {
  return photo.alt || getPhotoDisplayName(photo, t)
}

export function getListingMosaicPhotoSrc({ isLead, photo }) {
  return isLead
    ? photo.url || photo.origin || getPhotoImageSrc(photo)
    : getPhotoImageSrc(photo)
}

export function toListingMosaicPreviewPhotos(photos) {
  return photos.filter(photo => photo.url)
}

export function getIsListingMosaicPhotoCell(cell) {
  return cell.type === LISTING_PHOTO_MOSAIC_CELL_TYPE.photo
}

export function getIsListingMosaicAddCell(cell) {
  return cell.type === LISTING_PHOTO_MOSAIC_CELL_TYPE.add
}

export function getHasListingMosaicPhotos(photos) {
  return photos.length > 0
}
